import { useCallback, useEffect, useRef, useState } from "react";
import api from "@/lib/api";

export function useDebounced(value, ms = 400) {
  const [v, setV] = useState(value);
  useEffect(() => { const t = setTimeout(() => setV(value), ms); return () => clearTimeout(t); }, [value, ms]);
  return v;
}

// Shows the first page immediately, then loads every matching record in the background so
// search (server-side) and quick/advanced filters (client-side) cover the entire data set.
export function usePaged(path, params = {}) {
  const [data, setData] = useState(null);
  const [complete, setComplete] = useState(false);
  const key = JSON.stringify(params);
  const seq = useRef(0);
  const load = useCallback(async () => {
    const n = ++seq.current;
    const q = new URLSearchParams(Object.entries(JSON.parse(key)).filter(([, v]) => v !== "" && v != null));
    setData(null); setComplete(false);
    q.set("page", 1); q.set("page_size", 50);
    const { data: first } = await api.get(`${path}?${q}`);
    if (n !== seq.current) return;
    setData(first);
    if (first.total <= first.items.length) { setComplete(true); return; }
    q.set("all_rows", 1);
    const { data: full } = await api.get(`${path}?${q}`);
    if (n === seq.current) { setData(full); setComplete(true); }
  }, [path, key]);
  useEffect(() => { load(); }, [load]);
  return { rows: data ? data.items : null, data, total: data?.total ?? 0, complete, reload: load };
}
